// FIDS — helper utilities to derive intelligence attributes.

export const STATUS_MAP = {
  "high-potential": {
    key: "high-potential",
    label: "فرصة عالية",
    tone: "opportunity",
    description: "نقاط عالية + تحقّق قوي من المصادر.",
  },
  validated: {
    key: "validated",
    label: "مؤكّدة",
    tone: "intel",
    description: "مصادر موثوقة + خطوات تنفيذية واضحة.",
  },
  emerging: {
    key: "emerging",
    label: "ناشئة",
    tone: "intel-soft",
    description: "قطاع أو إشارة سوق في مرحلة نمو مبكر.",
  },
  watchlist: {
    key: "watchlist",
    label: "قيد المتابعة",
    tone: "warning",
    description: "الفرصة واعدة لكنها تحتاج تحقّقاً إضافياً.",
  },
  "high-risk": {
    key: "high-risk",
    label: "مخاطرة مرتفعة",
    tone: "risk",
    description: "عوامل خطر متعدّدة يجب تقييمها قبل التحرّك.",
  },
};

export const MARKET_IMPACT_MAP = {
  national: { label: "نطاق وطني", tone: "intel" },
  regional: { label: "نطاق إقليمي", tone: "opportunity" },
  local: { label: "نطاق محلي", tone: "warning-soft" },
};

export const TIME_SENSITIVITY_MAP = {
  urgent: { label: "عاجل", tone: "risk" },
  "30-days": { label: "خلال 30 يوماً", tone: "warning" },
  flexible: { label: "مرن الأمد", tone: "intel-soft" },
};

/** Fallback: derive a reasonable status when meta is missing. */
export const deriveStatus = (opportunity, meta) => {
  if (meta?.status && STATUS_MAP[meta.status]) return STATUS_MAP[meta.status];
  if (opportunity.score >= 85) return STATUS_MAP["high-potential"];
  if (opportunity.score >= 75) return STATUS_MAP.validated;
  if (
    opportunity.type === "إشارة السوق المبكرة" ||
    opportunity.type === "القطاع الصاعد"
  )
    return STATUS_MAP.emerging;
  if (opportunity.score >= 65) return STATUS_MAP.watchlist;
  return STATUS_MAP["high-risk"];
};

/** Tailwind class map for a given semantic tone. Solid + soft variants. */
export const TONE_CLASSES = {
  opportunity: {
    solid: "bg-opportunity-500 text-white border-opportunity-500",
    soft: "bg-opportunity-50 text-opportunity-700 border-opportunity-100",
    text: "text-opportunity-600",
    dot: "bg-opportunity-500",
  },
  intel: {
    solid: "bg-intel-800 text-white border-intel-800",
    soft: "bg-intel-50 text-intel-800 border-intel-100",
    text: "text-intel-700",
    dot: "bg-intel-700",
  },
  "intel-soft": {
    solid: "bg-intel-100 text-intel-800 border-intel-200",
    soft: "bg-intel-50 text-intel-700 border-intel-100",
    text: "text-intel-700",
    dot: "bg-intel-500",
  },
  warning: {
    solid: "bg-warning-500 text-white border-warning-500",
    soft: "bg-warning-50 text-warning-700 border-warning-100",
    text: "text-warning-600",
    dot: "bg-warning-500",
  },
  "warning-soft": {
    solid: "bg-warning-100 text-warning-700 border-warning-100",
    soft: "bg-warning-50 text-warning-700 border-warning-100",
    text: "text-warning-600",
    dot: "bg-warning-500",
  },
  risk: {
    solid: "bg-risk-500 text-white border-risk-500",
    soft: "bg-risk-50 text-risk-700 border-risk-100",
    text: "text-risk-600",
    dot: "bg-risk-500",
  },
};
